import { UPDATE_DYNAMIC_STATE } from "./actions";

const initState = {
    dynamic: {
        currentTime: 0,
        formattedTime: '0:00',
        buffering: true,
        startBuffer: 0,
        endBuffer: 0,
    }
};

const rootReducer = (state = initState, action) => {
    switch (action.type) {
        case UPDATE_DYNAMIC_STATE:
            return {
                ...state,
                dynamic: {
                    ...state.dynamic,
                    ...action.payload
                }
            };
        default:
            return state;
    }
};


export { rootReducer };